import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import { SkillsApi } from '@/lib/api/skills';
import type { Skill } from '@/lib/api/types/skills';
import { capacityQueryKeys } from '@/lib/query-keys/capacity';

export const getSkillsQueryOptions = () => {
  return {
    queryKey: capacityQueryKeys.skills.all(),
    queryFn: async () => {
      const skills = await SkillsApi.getSkills();
      return Array.isArray(skills) ? skills.sort((a, b) => a.name.localeCompare(b.name)) : [];
    },
  };
};

export const useSkillsQuery = (options: Partial<UseQueryOptions<Skill[]>> = {}) => {
  return useQuery({ ...getSkillsQueryOptions(), ...options });
};
